import React, {useState} from "react";
import DAFNTable from "./DAFNTable/DAFNTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../utils/utils";
import { useTranslation } from "react-i18next";

function DAFNCard(props) {
    const { t } = useTranslation()

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);

    const {dafn, isPDF, person_type} = props
    let initialExpand =  isPDF ? isPDF : dafn.flag === "negative" 

    if (initialExpand !== expanded && firstTime===true){
        setExpanded(initialExpand);
    }

    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("dafn")}
                    {/* Indica de o contribuinte está inscrito em dívida ativa da União e do FGTS */}
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(dafn.flag)}
                </div>
                {dafn.data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>             
                }                    
            </div>
            {dafn.data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <DAFNTable dafn_data={dafn.data} person_type={person_type}/>
                </div>
            </Collapse> 
            }     
        </div>
        );
}

export default DAFNCard